"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcularMontos = void 0;
const calcularMontos = (cfeInfo) => {
    let MntNoGrv;
    let MntNetoIVATasaMinima;
    let MntIVaenSusp;
    let MntExpoyAsim;
    let MntImpuestoPerc;
    let MntNetoIVATasaBasica;
    let MntIVATasaMin;
    let MntIVATasaBasica;
    let MontoNF;
    let MntPagar;
    let IVATasaMin;
    let IVATasaBasica;
    let MntTotRetenido;
    let MntNetoIVAOtra;
    let MntIVAOtra;
    let subtotal;
    let totalIVA;
    if (cfeInfo.MntNoGrv)
        MntNoGrv = Number(cfeInfo.MntNoGrv);
    else
        MntNoGrv = 0;
    if (cfeInfo.MntNetoIVATasaMinima)
        MntNetoIVATasaMinima = Number(cfeInfo.MntNetoIVATasaMinima);
    else
        MntNetoIVATasaMinima = 0;
    if (cfeInfo.MntIVaenSusp)
        MntIVaenSusp = Number(cfeInfo.MntIVaenSusp);
    else
        MntIVaenSusp = 0;
    if (cfeInfo.MntExpoyAsim)
        MntExpoyAsim = Number(cfeInfo.MntExpoyAsim);
    else
        MntExpoyAsim = 0;
    if (cfeInfo.MntImpuestoPerc)
        MntImpuestoPerc = Number(cfeInfo.MntImpuestoPerc);
    else
        MntImpuestoPerc = 0;
    if (cfeInfo.MntNetoIVATasaBasica)
        MntNetoIVATasaBasica = Number(cfeInfo.MntNetoIVATasaBasica);
    else
        MntNetoIVATasaBasica = 0;
    if (cfeInfo.MntIVATasaMin)
        MntIVATasaMin = Number(cfeInfo.MntIVATasaMin);
    else
        MntIVATasaMin = 0;
    if (cfeInfo.MntIVATasaBasica)
        MntIVATasaBasica = Number(cfeInfo.MntIVATasaBasica);
    else
        MntIVATasaBasica = 0;
    if (cfeInfo.MontoNF)
        MontoNF = Number(cfeInfo.MontoNF);
    else
        MontoNF = 0;
    if (cfeInfo.MntPagar)
        MntPagar = Number(cfeInfo.MntPagar);
    else
        MntPagar = 0;
    if (cfeInfo.IVATasaMin)
        IVATasaMin = Number(cfeInfo.IVATasaMin);
    else
        IVATasaMin = 0;
    if (cfeInfo.IVATasaBasica)
        IVATasaBasica = Number(cfeInfo.IVATasaBasica);
    else
        IVATasaBasica = 0;
    if (cfeInfo.MntTotRetenido)
        MntTotRetenido = Number(cfeInfo.MntTotRetenido);
    else
        MntTotRetenido = 0;
    if (cfeInfo.MntNetoIVAOtra)
        MntNetoIVAOtra = Number(cfeInfo.MntNetoIVAOtra);
    else
        MntNetoIVAOtra = 0;
    if (cfeInfo.MntIVAOtra)
        MntIVAOtra = Number(cfeInfo.MntIVAOtra);
    else
        MntIVAOtra = 0;
    subtotal = MntNoGrv + MntNetoIVATasaMinima + MntNetoIVATasaBasica + MntNetoIVAOtra + MntExpoyAsim;
    totalIVA = MntIVATasaMin + MntIVATasaBasica + MntIVAOtra;
    const montos = {
        MntNoGrv: MntNoGrv,
        MntNetoIVATasaMinima: MntNetoIVATasaMinima,
        MntIVaenSusp: MntIVaenSusp,
        MntExpoyAsim: MntExpoyAsim,
        MntImpuestoPerc: MntImpuestoPerc,
        MntNetoIVATasaBasica: MntNetoIVATasaBasica,
        MntIVATasaMin: MntIVATasaMin,
        MntIVATasaBasica: MntIVATasaBasica,
        MontoNF: MontoNF,
        MntPagar: MntPagar,
        IVATasaMin: IVATasaMin,
        IVATasaBasica: IVATasaBasica,
        MntTotRetenido: MntTotRetenido,
        MntNetoIVAOtra: MntNetoIVAOtra,
        MntIVAOtra: MntIVAOtra,
        subtotal: subtotal,
        totalIVA: totalIVA
    };
    return montos;
};
exports.calcularMontos = calcularMontos;
